<script setup lang="tsx">
import type { CondoCtaCardProps } from '.';

import { useEvents } from '~/composables/events/useEvents';
import { MixpanelProps } from '~/core/service/mixpanel';

import { CtaCard } from '~/components/CtaCard';

const { advertisePropertyTypeformId } = useRuntimeConfig().public;

const { openTypeform } = useTypeformPopup(advertisePropertyTypeformId);
const route = useRoute();
const { user } = useUserSession();
const { trackFormSellingClicked } = useEvents();

defineProps<CondoCtaCardProps>();

function handleTrackFormSellingClicked() {
	trackFormSellingClicked({
		[MixpanelProps.CTA_TEXT]: 'Anunciar meu imóvel',
		[MixpanelProps.USER_NAME]: user.value?.name || '',
		[MixpanelProps.USER_EMAIL]: user.value?.email || '',
		[MixpanelProps.USER_PHONE]: user.value?.phoneNumber || '',
		[MixpanelProps.CURRENT_PAGE]: route.fullPath,
		[MixpanelProps.SECTION_NAME]: 'property location'
	});
}

function handleOpenTypeform() {
	handleTrackFormSellingClicked();
	openTypeform();
}
</script>
<template>
	<section v-if="condo" class="size-full">
		<h3
			class="pb-7 font-matter-sq text-2xl leading-normal tracking-[-0.2px] text-primary md:text-[32px]"
		>
			Anuncie seu imóvel no {{ condo.name }}
		</h3>
		<CtaCard
			:image-src="condo.images[0]?.url"
			image-sizes="340px"
			image-class="lg:max-w-[340px]"
		>
			<template #title>
				Você é proprietário de um imóvel neste condomínio?
			</template>
			<template #description>
				Anuncie no PilarHomes, a plataforma especializada em imóveis de alto
				padrão, e conecte-se diretamente a compradores qualificados. Seu imóvel
				pode estar na vitrine ideal para um público exclusivo.
			</template>
			<template #extra-content>
				<Button
					class="mt-2 size-min md:text-sm"
					size="md"
					@click="handleOpenTypeform()"
				>
					Anunciar meu imóvel

					<IconMaterialSymbolsNorthEastRounded class="size-5" />
				</Button>
			</template>
		</CtaCard>
	</section>
</template>
